// src/serviceWorkerRegistration.ts - ✅ PHASE 2.1 : Service Worker Registration pour PWA

// Ce fichier est généré automatiquement par react-scripts avec Workbox
// Configuration du Service Worker pour le cache offline

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] est l'adresse IPv6 localhost.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 sont considérées comme localhost pour IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

type Config = {
  onSuccess?: (registration: ServiceWorkerRegistration) => void;
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
};

export function register(config?: Config) {
  if ('serviceWorker' in navigator) {
    // L'URL du service worker est générée automatiquement par Workbox
    const publicUrl = new URL(process.env.PUBLIC_URL || '', window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Le service worker ne fonctionnera pas si PUBLIC_URL est sur un domaine différent.
      // Cela peut arriver sur un CDN.
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // En localhost, vérifier si le service worker existe encore et informer le développeur.
        checkValidServiceWorker(swUrl, config);

        // En localhost, le navigateur vérifiera périodiquement les mises à jour.
        navigator.serviceWorker.ready.then(() => {
          console.log('✅ Service Worker prêt en localhost');
        });
      } else {
        // En production, enregistrer le service worker
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl: string, config?: Config) {
  navigator.serviceWorker
    .register(swUrl, { updateViaCache: 'none' }) // Force la vérification à chaque fois
    .then((registration) => {
      // Vérifier immédiatement s'il y a une mise à jour en attente
      if (registration.waiting) {
        console.log('🔄 Service Worker en attente détecté');
        if (config && config.onUpdate) {
          config.onUpdate(registration);
        }
      }

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              console.log('🔄 New content available, please refresh the page.');
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              console.log('✅ Content cached for offline use.');
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };

      // Vérification périodique des mises à jour (toutes les 60 secondes)
      setInterval(() => {
        registration.update();
      }, 60000);
    })
    .catch((error) => {
      console.error('❌ Error while registering the Service Worker:', error);
    });
}

function checkValidServiceWorker(swUrl: string, config?: Config) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker trouvé. Enregistrer normalement.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('⚠️ Pas de connexion internet trouvée. L\'application fonctionne en mode hors ligne.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}

